var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2436 17.011L3.79299 17.02C1.71386 17.0219 0.0113423 15.3227 0.00897964 13.2436L1.57532e-06 3.79299C-0.00188854 1.71386 1.69732 0.0113423 3.77645 0.00897964L13.227 1.57532e-06C15.3061 -0.00188854 17.0087 1.69732 17.011 3.77645L17.02 13.227C17.0224 15.3066 15.3227 17.0091 13.2436 17.011Z",
    fill: "url(#paint0_radial_1_523)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2436 17.011L3.79299 17.02C1.71386 17.0219 0.0113423 15.3227 0.00897964 13.2436L1.57532e-06 3.79299C-0.00188854 1.71386 1.69732 0.0113423 3.77645 0.00897964L13.227 1.57532e-06C15.3061 -0.00188854 17.0087 1.69732 17.011 3.77645L17.02 13.227C17.0224 15.3066 15.3227 17.0091 13.2436 17.011Z",
    fill: "url(#paint1_radial_1_523)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51033 11.818C6.68685 11.818 5.20264 10.3342 5.20264 8.51029C5.20264 6.68633 6.68685 5.20259 8.51033 5.20259C10.3338 5.20259 11.818 6.68633 11.818 8.51029C11.818 10.3342 10.3338 11.818 8.51033 11.818ZM8.51033 6.14765C7.20757 6.14765 6.14769 7.20753 6.14769 8.51029C6.14769 9.81305 7.20757 10.8729 8.51033 10.8729C9.81309 10.8729 10.873 9.81305 10.873 8.51029C10.873 7.20753 9.81309 6.14765 8.51033 6.14765Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.054 5.67506C12.4455 5.67506 12.7628 5.35772 12.7628 4.96627C12.7628 4.57481 12.4455 4.25748 12.054 4.25748C11.6626 4.25748 11.3452 4.57481 11.3452 4.96627C11.3452 5.35772 11.6626 5.67506 12.054 5.67506Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3452 14.6531H5.67489C3.8514 14.6531 2.36719 13.1694 2.36719 11.3454V5.67507C2.36719 3.85111 3.8514 2.36737 5.67489 2.36737H11.3452C13.1687 2.36737 14.6529 3.85111 14.6529 5.67507V11.3454C14.6529 13.1694 13.1687 14.6531 11.3452 14.6531ZM5.67489 3.31243C4.37212 3.31243 3.31224 4.37231 3.31224 5.67507V11.3454C3.31224 12.6482 4.37212 13.708 5.67489 13.708H11.3452C12.648 13.708 13.7079 12.6482 13.7079 11.3454V5.67507C13.7079 4.37231 12.648 3.31243 11.3452 3.31243H5.67489Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_523",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.32716 17.0323) scale(21.216 21.216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_523",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.73878 -0.212493) scale(14.0875 9.38649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bd0c52cd562cb78115199ad483c62682.svg";
export { ForwardRef as ReactComponent };